import React from "react"
import { Link} from 'gatsby'
import { RichText, Wrapper, Background, Padder, List } from 'components'
import {Layout, Viewport, Title, Card, } from "../../components"
import * as S from './styles'
import { getPath} from '../../utility'

export default (props) => {
  const { translations, siteMetadata } = props.pageContext

  const { as2fe, routes, richText_4 } = translations
  
  const industriesPath = routes.find(route => route.template === "industries")
const { pathPrefix } = siteMetadata
  return (
  <Layout {...props}>
    <Wrapper size="large">
    <RichText text={richText_4} />
    </Wrapper>
    <Padder size="regular">
      <Background color="#f9fafa">
          <Padder size="big">
            <Wrapper size="large">
            <Title title={as2fe}>
            <List columns="3">
                {industriesPath.routes.map((industry, index) => (
                  <Viewport key={industry.slug}>
                  {() => {
                    
                    const image = {
                      src: getPath(industry.metaImage, pathPrefix)
                    }
               
                    const disabled = industry.hidden

                    return (
                      disabled
                      ? (
                        <S.CardWrapper disabled={disabled}>
                          <Card image={image} title={industry.label} text={industry.metaDescription} />
                        </S.CardWrapper>
                      )
                      : (
                        <Link to={`${industriesPath.slug}/${industry.slug}`}>
                          <S.CardWrapper>
                            <Card image={image} title={industry.label} text={industry.metaDescription} />
                          </S.CardWrapper>
                        </Link>
                      )
                    )
                  }

              }
              </Viewport>
              ))}
            </List>
          </Title>
          </Wrapper>
        </Padder>
      </Background>
      </Padder>
      
  </Layout>
)}
